import * as React from 'react'
import { IFilter } from '../../types'
import FilterItem from './FilterItem'

interface ISelectedFilters {
  id: string
  name: string
}

interface IVehiclesFilterProps {
  applyFilters?: (filters: ISelectedFilters[]) => void
  getParamsFilter?: () => void
  isError?: boolean
  isFetch?: boolean
  paramsFilter?: IFilter[]
  toggleFilter?: () => void
}

interface IVehiclesFilterState {
  isShowMore: boolean
  selectedFilters: ISelectedFilters[]
}

class VehiclesFilter extends React.Component<IVehiclesFilterProps, IVehiclesFilterState> {
  constructor(props: any) {
    super(props)
    this.state = {
      isShowMore: false,
      selectedFilters: []
    }
  }

  public componentDidMount() {
    if (this.props.getParamsFilter) {
      this.props.getParamsFilter()
    }
  }

  public render() {
    const filters = this.props.paramsFilter
      ? Object.values(this.props.paramsFilter)
          .splice(0, 2)
          .map((it: IFilter) => it)
      : []
    if (this.props.isError) {
      return <div>Error</div>
    }
    if (this.props.isFetch) {
      return (
        <div className='pt2 border-box full-height flex flex-wrap flex-column w260 absolute top-0 right-0 z2 bg-light-grey7'>
          Wait
        </div>
      )
    }
    return (
      <div className='pt2 border-box full-height flex flex-wrap flex-column w260 absolute top-0 right-0 z2 bg-light-grey7'>
        <div className='p2 h3 font-blue-grey bg-light-grey3'>Filter</div>
        {this.props.paramsFilter && <FilterItem data={filters || []} handleSelect={this.handleSelect} />}
        {this.state.isShowMore && (
          <FilterItem
            data={this.props.paramsFilter ? Object.values(this.props.paramsFilter) : []}
            handleSelect={this.handleSelect}
          />
        )}
        <div
          className='w93 center h6 bold py1 px2 border-grey6 ml-auto mr-auto uppercase bg-white cursor--pointer mt2'
          onClick={this.showMoreSwitch}
        >
          Show more
        </div>

        <div className='flex col-12 justify-around bg-light-grey3 py1 mt-auto'>
          <div
            onClick={this.props.toggleFilter}
            className='py1 px2 bg-light-grey3 border-white rounded font-light-blue-grey bold h5 cursor--pointer'
          >
            Cancel
          </div>
          <div className='py1 px2 bg-green rounded font-white bold h5 cursor--pointer' onClick={this.applyFilters}>
            Apply
          </div>
        </div>
      </div>
    )
  }

  private showMoreSwitch = () => this.setState({ isShowMore: !this.state.isShowMore })

  private handleSelect = (id: string, name: string) => () => {
    this.state.selectedFilters.find((it: any) => name === it.name)
      ? this.setState({
          selectedFilters: this.state.selectedFilters.filter((it: any) => it.name !== name)
        })
      : this.setState({
          selectedFilters: [...this.state.selectedFilters, { id, name }]
        })
  }
  private applyFilters = () => this.props.applyFilters && this.props.applyFilters(this.state.selectedFilters)
}

export default VehiclesFilter



// WEBPACK FOOTER //
// ./src/components/vehicles/VehiclesFilter.tsx